import React from "react";
import styled from "styled-components";
import * as Router from "next/router";
import * as Sentry from "@sentry/browser";

import * as u from "../utils";
import * as c from "../constants";
import * as gtag from "../utils/gtag";
import * as T from "./Typography";
import * as I from "./Icons";

export default function BackButton(props) {
  const router = Router.useRouter();
  React.useEffect(manageSessionStorage, []);
  const backText = props.text || "Back";

  return (
    <S.NavigateBack onClick={navigateBack} data-cy="back-button">
      <S.BackButton>
        <I.ArrowLeft color={u.colours.charcoal} />
      </S.BackButton>
      <T.CL>{backText}</T.CL>
    </S.NavigateBack>
  );

  function manageSessionStorage() {
    try {
      const maybeBackTo = u.sessionStorage.getItem(c.BACK_TO);
      if (typeof maybeBackTo !== "string") return;

      const backToPath = maybeBackTo.split("?")[0];
      if (router.asPath.includes(backToPath)) return;

      u.sessionStorage.removeItem(c.BACK_TO);
    } catch (err) {
      Sentry.captureException(err);
    }
  }

  function navigateBack() {
    gtag.event({
      name: gtag.GA_EVENT.PLATFORM_ENGAGEMENT,
      category: "UI",
      label: "Click back",
      value: router.route,
    });

    let backTo = props.backTo;
    try {
      if (u.sessionStorage.getItem(c.BACK_TO)) {
        backTo = u.sessionStorage.getItem(c.BACK_TO);
        u.sessionStorage.removeItem(c.BACK_TO);
      }
    } catch (err) {
      Sentry.captureException(err);
    }

    backTo ? router.push(backTo) : router.back();
  }
}

const S = {};

S.NavigateBack = styled.div`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  max-width: 1000px;
  :hover {
    filter: brightness(0.9);
  }
`;

S.BackButton = styled.div`
  background-color: ${u.colours.shellOverlay};
  border-radius: 50%;
  display: flex;
  margin-right: 20px;
  padding: 5px;
`;
